import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import moment from 'moment';
import { BarnyardIcon } from 'barnyard/icons';
import AlertItem from './AlertItem';
import ItemTable from './ItemTable';


const ItemHasNoCorporateItemLinkAlert = ({ alert, ...other }) => (
  <AlertItem
    alert={alert}
    date={moment(alert.date).format('MMMM YYYY')}
    icon={<BarnyardIcon icon={['fa', 'unlink']} className='DiscussCard__replyIcon' />}
    title={(
      <div>
        <Link to={`/corporate/analyze/buyer/${alert.buyer.id}`}>
          {alert.buyer.name}
        </Link>
        {' '} has purchased an unlinked item
      </div>
    )}
    content={(
      <ItemTable
        includeExport={true}
        items={alert.value.items}
      />
    )}
    {...other}
  />
);

ItemHasNoCorporateItemLinkAlert.propTypes = {
  alert: PropTypes.object.isRequired,
  onIsDeletedChange: PropTypes.func.isRequired,
  onIsFlaggedChange: PropTypes.func.isRequired
};

export default ItemHasNoCorporateItemLinkAlert;
